import {memo} from 'react';

import type {SVGProps} from 'react';

export const AddListIcon = memo(function AddListIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none">
        <path
          d="M13.6663 3.75H6.74967C6.04134 3.75 5.45801 4.33333 5.45801 5.04167V18.3333C5.45801 19.0417 6.04134 19.625 6.74967 19.625H16.6247C17.333 19.625 17.9163 19.0417 17.9163 18.3333V7.95833C17.9163 7.75 17.833 7.54167 17.6663 7.375L14.2913 4C14.1247 3.83333 13.9163 3.75 13.6663 3.75Z"
          fill="var(--icon-fill-cyan)"
        />
        <path
          d="M16.042 8.70833V6.04166H13.1253C12.667 6.04166 12.292 5.66666 12.292 5.20833V2.29166"
          stroke="var(--icon-stroke-cyan)"
          strokeWidth={1.25}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.95801 8.04166V16.4583C3.95801 17.1667 4.49967 17.7083 5.20801 17.7083H9.79134"
          stroke="var(--icon-stroke-cyan)"
          strokeWidth={1.25}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.2913 2.29166H5.20801C4.49967 2.29166 3.95801 2.83333 3.95801 3.54166V5.29166"
          stroke="var(--icon-stroke-cyan)"
          strokeWidth={1.25}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.042 6.04166L12.292 2.29166"
          stroke="var(--icon-stroke-cyan)"
          strokeWidth={1.25}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.45801 8.54166H6.87467"
          stroke="var(--icon-stroke-cyan)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.95801 8.54166H13.5413"
          stroke="var(--icon-stroke-cyan)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.45801 11.0417H6.87467"
          stroke="var(--icon-stroke-cyan)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.95801 11.0417H12.9163"
          stroke="var(--icon-stroke-cyan)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.45801 13.5417H6.87467"
          stroke="var(--icon-stroke-cyan)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.95801 13.5417H11.1247"
          stroke="var(--icon-stroke-cyan)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.5003 17.625C16.8337 18.2083 15.9587 18.5417 15.0003 18.5417C12.8337 18.5417 11.042 16.7917 11.042 14.5833C11.042 12.375 12.792 10.625 15.0003 10.625C17.2087 10.625 18.9587 12.375 18.9587 14.5833"
          stroke="var(--icon-stroke-cyan)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 13.2083V15.9583"
          stroke="var(--icon-stroke-cyan)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.375 14.5833H13.625"
          stroke="var(--icon-stroke-cyan)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
});
